import { brandMarkStyles } from './BrandMark.styles';

import { cn } from '@/lib/cn';

export interface BrandMarkProps {
  className?: string;
}

/**
 * The Meeply mark: the blue-to-violet tile with a meeple knocked out of it.
 *
 * Warning: drawn by the stylesheet (`brand-mark` in `theme.css`), not by an
 * inline SVG. The mark sits in the navigation, on the first screen, and its
 * path data as JSX was the kilobyte that pushed the initial JavaScript past
 * its budget. The drawing is the same as `public/favicon.svg`.
 *
 * Decoration: the name beside it is what gets read out.
 */
export function BrandMark({ className }: Readonly<BrandMarkProps>) {
  return <span aria-hidden className={cn(brandMarkStyles(), className)} />;
}
